import axios from 'axios';
import { client } from '@/services/api/axios.ts'; // Adjust this import if necessary
import { useMutation } from '@tanstack/react-query';

// Define the type for the request payload
type TForgotPasswordRequest = {
  email: string;
};

// Define the async function to call the forgot password API
async function forgotPassword({
  email,
}: TForgotPasswordRequest): Promise<{ message: string } | undefined | void> {
  try {
    const { data } = await client.post('/auth/forgot-password', { email });

    return data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(`${error?.response?.data?.message || 'An error occurred'}`);
    }

    if (error instanceof Error) {
      throw new Error(`${error.message}`);
    }
  }
}

// Export the custom hook to be used in the ForgotPassword component
export const useForgotPasswordMutation = ({ onSuccess }: { onSuccess?: () => void }) => {
  return useMutation({
    mutationFn: forgotPassword,
    onSuccess: () => {
      if (onSuccess) onSuccess();
    },
  });
};
